import type { ColumnDef } from "@tanstack/react-table";
import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/ui/data-table";
import { AuditLogActorLabel } from "@/features/audit-logs/components/AuditLogActorLabel";
import { auditLogSummary } from "@/features/audit-logs/lib/audit-log-display";
import { formatOptionalArabicDateTime } from "@/lib/formatters";
import type { AuditLog } from "@/types/audit-log";

interface AuditLogsTableProps {
  logs: AuditLog[];
  departmentLookup: Record<string, string>;
  pageIndex: number;
  pageCount: number;
  onPageChange: (pageIndex: number) => void;
  onViewDetail: (log: AuditLog) => void;
}

export function AuditLogsTable({
  logs,
  departmentLookup,
  pageIndex,
  pageCount,
  onPageChange,
  onViewDetail,
}: AuditLogsTableProps) {
  const columns: ColumnDef<AuditLog>[] = [
    {
      id: "action",
      header: "الإجراء",
      accessorFn: (row) => auditLogSummary(row).actionLabel,
    },
    {
      id: "resource",
      header: "المورد",
      accessorFn: (row) => auditLogSummary(row).resourceLabel,
    },
    {
      id: "user",
      header: "المستخدم",
      cell: ({ row }) => <AuditLogActorLabel userId={row.original.userId} />,
    },
    {
      id: "department",
      header: "الدائرة",
      accessorFn: (row) =>
        row.departmentId
          ? (departmentLookup[row.departmentId] ?? row.departmentId)
          : "—",
    },
    {
      accessorKey: "ipAddress",
      header: "IP",
      cell: ({ row }) => row.original.ipAddress ?? "—",
    },
    {
      id: "createdAt",
      header: "التاريخ",
      accessorFn: (row) => formatOptionalArabicDateTime(row.createdAt),
    },
    {
      id: "actions",
      header: "",
      cell: ({ row }) => (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onViewDetail(row.original)}
        >
          عرض
        </Button>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={logs}
      manualPagination={{
        pageIndex,
        pageCount,
        onPageChange,
      }}
    />
  );
}
